import { useQuery, useQueryClient } from '@tanstack/react-query'
import { listOverrideRules } from '../../../api/plan-benefit-override-rules-api'
import type { PlanBenefitOverrideRuleResponseDto } from '../../../api/dto/plan-benefit-override-rules.dto'

export const FIND_OVERRIDE_RULE_QUERY_KEY = 'findOverrideRuleByMatch'

interface MatchParams {
  year: number
  hiosPlanId: string
  benefitName: string
}

export function useFindOverrideRuleByMatch(params: MatchParams | null) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [FIND_OVERRIDE_RULE_QUERY_KEY, params],
    queryFn: () => {
      if (!params) return Promise.reject(new Error('params required'))
      return listOverrideRules({
        year: params.year,
        hiosPlanId: params.hiosPlanId,
        benefitName: params.benefitName,
        limit: 1,
      })
    },
    enabled: params !== null,
    staleTime: 0,
    gcTime: 0,
  })

  const rule: PlanBenefitOverrideRuleResponseDto | null = data?.data[0] ?? null

  return { rule, isLoading, refetch }
}

export function useInvalidateFindOverrideRule() {
  const queryClient = useQueryClient()
  return () =>
    queryClient.invalidateQueries({
      queryKey: [FIND_OVERRIDE_RULE_QUERY_KEY],
    })
}
